<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3>ព័ត៌មានអ្នកទីផ្សារ</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">

				<md-table>
					<md-table-row>
						<md-table-cell style="width: 40%;">លេខកូដអ្នកទីផ្សារ</md-table-cell>
						<md-table-cell style="width: 5px">៖</md-table-cell>
						<md-table-cell>
							<span v-if="String(referral.hash_id).length > 0">{{referral.hash_id}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ឈ្មោះអ្នកទីផ្សារ</md-table-cell>
						<md-table-cell>៖</md-table-cell>
						<md-table-cell>
							<span v-if="String(referral.name).length > 0">{{referral.name}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>លេខទូរស័ព្ទអ្នកទីផ្សារ</md-table-cell>
						<md-table-cell>៖</md-table-cell>
						<md-table-cell>
							<span v-if="String(referral.phone).length > 0">{{referral.phone}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<!-- <h3>referral Detail</h3> -->
				<md-table>
					<md-table-row>
						<md-table-cell>ថ្ងៃបានបង្កើត</md-table-cell>
						<md-table-cell>៖</md-table-cell>
						<md-table-cell>
							<span v-if="String(referral.created_date).length > 0">{{config.datelify(referral.created_date)}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>កំណត់ចំណាំផ្សេងៗ</md-table-cell>
						<md-table-cell>៖</md-table-cell>
						<md-table-cell>
							<span v-if="String(referral.note).length > 0">{{referral.note}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
			<!-- <div class="md-layout-item md-small-size-100 md-size-50">
				<h3>Loan Detail</h3>
				<md-table>
					<md-table-row>
						<md-table-cell style="width: 40%;">Total Loan Amount</md-table-cell>
						<md-table-cell style="width: 5px">៖</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.name).length > 0">$5,000.00</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>Total Loan</md-table-cell>
						<md-table-cell>៖</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.name_khmer).length > 0">2 Loans</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>Total payment</md-table-cell>
						<md-table-cell>៖</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.phone).length > 0">$6,300.00</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>Remaining balance</md-table-cell>
						<md-table-cell>៖</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.note).length > 0">$4,725.00</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div> -->
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3>ព័ត៌មានស្ថិតិអំពីកញ្ចប់ឥវ៉ាន់</h3>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>today</md-icon>
					</template>
					<template slot="content">
						<p class="category">កញ្ចប់ឥវ៉ាន់ថ្ងៃនេះ</p>
						<h3 class="title">{{data.total_today}}</h3>
					</template>
				</stats-card>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>today</md-icon>
					</template>
					<template slot="content">
						<p class="category">កញ្ចប់ឥវ៉ាន់ ៧ ថ្ងៃចុងក្រោយ</p>
						<h3 class="title">{{data.total_7_day}}</h3>
					</template>
				</stats-card>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>today</md-icon>
					</template>
					<template slot="content">
						<p class="category">កញ្ចប់ឥវ៉ាន់ ៣០ ថ្ងៃចុងក្រោយ</p>
						<h3 class="title">{{data.total_30_day}}</h3>
					</template>
				</stats-card>
			</div>
			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
				<stats-card data-background-color="orange">
					<template slot="header">
						<md-icon>today</md-icon>
					</template>
					<template slot="content">
						<p class="category">កញ្ចប់ឥវ៉ាន់សរុប</p>
						<h3 class="title">{{data.total_package}}</h3>
					</template>
				</stats-card>
			</div>
		</div>
	</div>
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	import StatsCard from '@/components/Cards/StatsCard'
	export default {
		components: { Datetime, StatsCard },
		created() {

			// this.getLocation();
			// this.getSettings();
			this.getReferral();
			// this.getPackage();
			// this.searchHandler();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				referral: {
					hash_id: "",
					name: "",
					phone: "",
					note: "",
					created_date: ""
				},
				data: {
					total_package: 0,
					total_today: 0,
					total_7_day: 0,
					total_30_day: 0
				},
				loadMore: false,
				packageList: []

			}
		},
		methods: {
			getReferral() {
				this.$http.get(this.config.api + "/admin/referral/get/" + this.$route.params.hash_id).then(data => {
					this.referral = data.body.data
					this.loaded = true;
				})
				// this.$http.get(this.config.api + "/admin/referral/get/package_stat/" + this.$route.params.hash_id).then(data => {
				// 	this.data = data.body.data
				// })
			},
			getPackage(more = false) {
				this.$http.post(this.config.api + "/admin/referral/get/package", {
					hash_id: this.$route.params.hash_id,
					offset: more ? this.packageList.length : 0
				}).then(data => {
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.packageList = more ? this.packageList.concat(data.body.data) : data.body.data;
				})
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Referral/Detail.vue